import React from 'react';
import './index.css';
import { Label14 } from './index';

export const UploadErrorCard = ({ title = "", desc="", onClick=null }) => {
    const roleData = localStorage.getItem("role");
    let isSalesAdmin = false;
    if (roleData == "SALESADMIN") isSalesAdmin = true;

    const downBtnCSS = isSalesAdmin ? "label14 downloadStatusDisabled" : "label14 downloadStatus";
    return (
        <div className="divRow uploadStatusCard">
            <div className="uploadErrorIcon" />
            <div className="divRow uploadStatusMsg">
                <div className="divColumn" style={{ width: '70%' }}>
                    <Label14>{title}</Label14>
                    <div />
                    <label className="label12" style={{ color: '#6d758e', marginTop: 4 }}>{desc}</label>
                </div>
                {onClick && <a onClick={isSalesAdmin ? null : onClick}><label className={downBtnCSS}>Download</label></a>}
            </div>
        </div>
    );
}